// ============================================================================
// File: components/layout/DashboardFilters.jsx
// Purpose: Global dashboard filters (Phase 2)
// ============================================================================

import React from "react";

export default function DashboardFilters() {
  return (
    <div className="dashboard-filters">
      <span>Filters coming soon...</span>
    </div>
  );
}
